import React from "react";
import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import { Button } from "./ui/button";

export const MobileNav = () => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Menu">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] sm:w-[400px]">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col gap-4 py-4">
          <a
            href="/about"
            className="px-4 py-2 text-sm font-medium hover:bg-accent rounded-md transition-colors"
          >
            About
          </a>
          <div className="px-4 py-2">
            <p className="text-sm font-medium mb-2">Treatments</p>
            <div className="pl-4 flex flex-col gap-2">
              <a
                href="/treatments/erectile-dysfunction"
                className="text-sm hover:text-primary transition-colors"
              >
                Erectile Dysfunction
              </a>
              <a
                href="/treatments/neuropathy"
                className="text-sm hover:text-primary transition-colors"
              >
                Neuropathy
              </a>
              <a
                href="/treatments/soft-tissue"
                className="text-sm hover:text-primary transition-colors"
              >
                Soft Tissue
              </a>
            </div>
          </div>
          <div className="px-4 py-2">
            <p className="text-sm font-medium mb-2">More</p>
            <div className="pl-4 flex flex-col gap-2">
              <a
                href="/research"
                className="text-sm hover:text-primary transition-colors"
              >
                Research
              </a>
              <a
                href="/contact-us"
                className="text-sm hover:text-primary transition-colors"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;
